import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { openCookieSettings } from '../../redux/cookieConsent/cookieConsentSlice';
import { useAppDispatch } from '../../redux/hooks';
import { ROUTE_PATH_NAMES } from '../../routes/router/routePathNames';
import { colors } from '../../theme/colors';
import spacing, { isMobileScreen } from '../../theme/spacing';
import { fontSize } from '../../theme/typography';
import DistributionFooter from './DistributionFooter';

const Footer = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const itemsGap = isMobileScreen ? spacing.medium : spacing.mediumLarge;

  const handleCookieSettings = () => {
    dispatch(openCookieSettings());
  };

  // Open legal pages in a new tab, keep cookie settings in place

  const linkStyle = {
    color: colors.textGreyMedium,
    opacity: 0.8,
    textDecoration: 'none',
    fontSize: fontSize.regular - 2,
    fontWeight: 400,
    cursor: 'pointer',
    transition: 'color 0.2s ease',
  };

  return (
    <footer
      style={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: colors.backgroundMediumLight,
        marginTop: 72,
      }}
    >
      {/* Distribution Footer */}
      <DistributionFooter />

      {/* Main Footer Content */}
      <div
        style={{
          display: 'flex',
          flexDirection: isMobileScreen ? 'column' : 'row',
          justifyContent: 'center',
          alignItems: isMobileScreen ? 'flex-start' : 'center',
          padding: `${spacing.large} ${spacing.medium}`,
        }}
      >
        <Link
          to={ROUTE_PATH_NAMES.PRIVACY_POLICY}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            ...linkStyle,
            marginTop: 0,
          }}
          onMouseEnter={(e) => {
            const target = e.currentTarget as HTMLAnchorElement;
            target.style.color = colors.textPrimary;
          }}
          onMouseLeave={(e) => {
            const target = e.currentTarget as HTMLAnchorElement;
            target.style.color = colors.textGreyMedium;
          }}
        >
          {t('footer.privacyPolicy')}
        </Link>

        <button
          onClick={handleCookieSettings}
          style={{
            ...linkStyle,
            background: 'none',
            border: 'none',
            padding: 0,
            marginLeft: isMobileScreen ? 0 : itemsGap,
            marginTop: isMobileScreen ? itemsGap : 0,
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = colors.textPrimary;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = colors.textGreyMedium;
          }}
        >
          {t('cookieConsent.cookieSettings')}
        </button>

        <Link
          to={ROUTE_PATH_NAMES.TERMS_OF_CONDITIONS}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            ...linkStyle,
            marginLeft: isMobileScreen ? 0 : itemsGap,
            marginTop: isMobileScreen ? itemsGap : 0,
          }}
          onMouseEnter={(e) => {
            const target = e.currentTarget as HTMLAnchorElement;
            target.style.color = colors.textPrimary;
          }}
          onMouseLeave={(e) => {
            const target = e.currentTarget as HTMLAnchorElement;
            target.style.color = colors.textGreyMedium;
          }}
        >
          {t('footer.termsOfConditions')}
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
